export default "__VITE_ASSET__DaUhdLad__"